import { type DefaultTheme } from "styled-components";

import {
	epicBorderRadius0,
	epicBorderRadius4,
	epicBorderRadius12,
	epicBorderRadius16,
	epicBorderRadius6,
	epicBorderRadius8,
	epicBorderRadius10,
	epicBorderRadius20,
	epicBorderRadius24,
	epicBorderRadiusFull,
} from "./border-radius";
import { EpicBreakpointInPx } from "./breakpoint";
import {
	epicError0,
	epicError20,
	epicError100,
	epicInfo0,
	epicInfo20,
	epicInfo100,
	epicOnPrimary,
	epicOnSecondary,
	epicPrimary20,
	epicPrimary40,
	epicPrimary80,
	epicPrimary100,
	epicSecondary20,
	epicSecondary40,
	epicSecondary80,
	epicSecondary100,
	epicSecondary120,
	epicShade0,
	epicShade10,
	epicShade100,
	epicShade20,
	epicShade40,
	epicShade5,
	epicShade60,
	epicShade80,
	epicSuccess0,
	epicSuccess20,
	epicSuccess100,
	epicWarning0,
	epicWarning20,
	epicWarning100,
} from "./colors";
import {
	EpicB1Typography,
	EpicH1Typography,
	EpicH2Typography,
	EpicH3Typography,
	EpicH4Typography,
	EpicL1Typography,
	EpicP1Typography,
	EpicP2Typography,
	EpicP3Typography,
} from "./fonts";
import {
	epicSpacing0,
	epicSpacing10,
	epicSpacing12,
	epicSpacing16,
	epicSpacing2,
	epicSpacing20,
	epicSpacing24,
	epicSpacing32,
	epicSpacing4,
	epicSpacing40,
	epicSpacing64,
	epicSpacing8,
	epicSpacing80,
	epicSpacing96,
} from "./spacing";

/**
 * @deprecated This theme should not be used
 */
export const DEFAULT_THEME: DefaultTheme = {
	colors: {
		primary20: epicPrimary20,
		primary40: epicPrimary40,
		primary80: epicPrimary80,
		primary100: epicPrimary100,
		secondary20: epicSecondary20,
		secondary40: epicSecondary40,
		secondary80: epicSecondary80,
		secondary100: epicSecondary100,
		secondary120: epicSecondary120,
		onPrimary: epicOnPrimary,
		onSecondary: epicOnSecondary,
		fontPrimary: epicShade100,
		fontDisabled: epicShade20,
		focus: epicInfo100,
		info0: epicInfo0,
		info20: epicInfo20,
		info100: epicInfo100,
		error0: epicError0,
		error20: epicError20,
		error100: epicError100,
		success0: epicSuccess0,
		success20: epicSuccess20,
		success100: epicSuccess100,
		warning0: epicWarning0,
		warning20: epicWarning20,
		warning100: epicWarning100,
		shade0: epicShade0,
		shade5: epicShade5,
		shade10: epicShade10,
		shade20: epicShade20,
		shade40: epicShade40,
		shade60: epicShade60,
		shade80: epicShade80,
		shade100: epicShade100,
	},
	fonts: {
		default: EpicP2Typography,
		H1: EpicH1Typography,
		H2: EpicH2Typography,
		H3: EpicH3Typography,
		H4: EpicH4Typography,
		P1: EpicP1Typography,
		P2: EpicP2Typography,
		P3: EpicP3Typography,
		L1: EpicL1Typography,
		B1: EpicB1Typography,
	},
	spacing: {
		spacing0: epicSpacing0,
		spacing2: epicSpacing2,
		spacing4: epicSpacing4,
		spacing8: epicSpacing8,
		spacing10: epicSpacing10,
		spacing12: epicSpacing12,
		spacing16: epicSpacing16,
		spacing20: epicSpacing20,
		spacing24: epicSpacing24,
		spacing32: epicSpacing32,
		spacing40: epicSpacing40,
		spacing64: epicSpacing64,
		spacing80: epicSpacing80,
		spacing96: epicSpacing96,
	},
	breakpoints: {
		medium: EpicBreakpointInPx.medium,
		large: EpicBreakpointInPx.large,
		xlarge: EpicBreakpointInPx.xlarge,
		xxlarge: EpicBreakpointInPx.xxlarge,
	},
	borderRadius: {
		borderRadius0: epicBorderRadius0,
		borderRadius4: epicBorderRadius4,
		borderRadius6: epicBorderRadius6,
		borderRadius8: epicBorderRadius8,
		borderRadius10: epicBorderRadius10,
		borderRadius12: epicBorderRadius12,
		borderRadius16: epicBorderRadius16,
		borderRadius20: epicBorderRadius20,
		borderRadius24: epicBorderRadius24,
		borderRadiusFull: epicBorderRadiusFull,
	},
};
